import React from 'react';
import { Route, Redirect as RouterRedirect } from "react-router-dom";
import SideNavigation from "../Components/SideNavigation";

const ProtectedRoute = ({ component: Component, ...rest }) => {
    const loggedUser = localStorage.getItem("jwt") ? true : false;
    return (
        <Route {...rest}
            render={(props) => {
                return loggedUser ? (
                    <SideNavigation history={props.history}>
                        <Component {...props} />
                    </SideNavigation>
                ) : (
                    <RouterRedirect to={{ pathname: "/", state: { from: props.location } }} />
                )
            }}
        />
    )
};


export default ProtectedRoute;